import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  container: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    minHeight: '100vh',
    '@supports (height: 100dvh)': {
      minHeight: '100dvh',
    },
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: theme.palette.text.primary,
    maxWidth: 420,
    width: '100%',
    padding: theme.spacing(3),
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    textAlign: 'center',
  },
  description: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    maxWidth: 360,
  },
  button: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
  iconCircle: {
    ...theme.mixins.appIconTintCircle,
    width: 112,
    height: 112,
    marginBottom: theme.spacing(3),
  },
  errorImage: {
    width: 52,
    height: 52,
    display: 'block',
  },
  statusCode: {
    fontSize: 64,
    lineHeight: 1,
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
}));
